module.exports = __webpack_public_path__ + "img/22.ff49603c.png";